import { render, staticRenderFns } from "./makmin.vue?vue&type=template&id=745bb5b7&"
import script from "./makmin.vue?vue&type=script&lang=js&"
export * from "./makmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports